import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
export function Bonuses() {
  return <section className="py-24 bg-slate-900 text-white relative overflow-hidden" data-id="element-27">
      {/* Accent background elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-28" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-emerald-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-29" />

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-31">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/20 text-amber-400 font-bold text-sm mb-6 border border-amber-500/30" data-id="element-32">
            <Gift className="w-4 h-4" data-id="element-33" />
            OFERTA ESPECIAL: BONUS PROFESIONALES
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-4" data-id="element-34">
            INCLUIDOS CON TU COMPRA
          </h2>
        </motion.div>

        <div className="space-y-12" data-id="element-35">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800/50 border border-slate-700 rounded-3xl p-8 md:p-10 backdrop-blur-sm" data-id="element-36">
            <div data-id="element-37">
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2
            }} className="inline-block px-3 py-1 bg-emerald-500 text-white font-bold text-xs rounded-md mb-4 uppercase tracking-wide" data-id="element-38">
                ¡Incluido hoy!
              </motion.div>
              <h3 className="text-2xl md:text-3xl font-display font-bold mb-4" data-id="element-39">
                BONUS #1 — Planillas de Seguimiento de Candidatos
              </h3>
              <p className="text-slate-300 mb-6 text-lg" data-id="element-40">
                Planillas descargables para registrar y seguir candidatos
                durante todo el proceso.
              </p>
              <p className="font-semibold text-white mb-4" data-id="element-41">
                Incluye planillas para:
              </p>
              <ul className="space-y-3 mb-6 grid sm:grid-cols-2 sm:gap-x-6" data-id="element-42">
                {['datos del candidato;', 'estado actual;', 'registro de entrevistas;', 'evaluación por criterios;', 'próximos pasos;', 'observaciones finales;', 'decisión.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-300" data-id="element-43">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-44" />
                    <span data-id="element-45">{item}</span>
                  </li>)}
              </ul>
              <p className="text-amber-400 font-medium italic" data-id="element-46">
                Para que no pierdas información entre etapas y puedas saber
                rápidamente qué pasa con cada perfil.
              </p>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800/50 border border-slate-700 rounded-3xl p-8 md:p-10 backdrop-blur-sm" data-id="element-47">
            <div data-id="element-48">
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2,
              delay: 1
            }} className="inline-block px-3 py-1 bg-emerald-500 text-white font-bold text-xs rounded-md mb-4 uppercase tracking-wide" data-id="element-49">
                ¡Incluido hoy!
              </motion.div>
              <h3 className="text-2xl md:text-3xl font-display font-bold mb-4" data-id="element-50">
                BONUS #2 — Planilla de Gestión de Búsquedas Activas
              </h3>
              <p className="text-slate-300 mb-6 text-lg" data-id="element-51">
                Sistema multi-hoja para recruiters que manejan varias posiciones
                al mismo tiempo.
              </p>
              <p className="font-semibold text-white mb-4" data-id="element-52">
                Incluye hojas para:
              </p>
              <ul className="space-y-3 mb-6 grid sm:grid-cols-2 sm:gap-x-6" data-id="element-53">
                {['panel de control general;', 'ficha de posición;', 'seguimiento de candidatos por búsqueda;', 'gestión de clientes;', 'agenda de entrevistas;', 'pipeline de cierre;', 'registro histórico.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-300" data-id="element-54">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-55" />
                    <span data-id="element-56">{item}</span>
                  </li>)}
              </ul>
              <p className="text-amber-400 font-medium italic" data-id="element-57">
                Para ver tus búsquedas activas, candidatos, clientes,
                entrevistas y cierres en un solo lugar.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}